import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import {
  Box,
  Button,
  Header,
  Text,
  TextInput,
  ValidatePassword,
  isPasswordStrong,
} from '~/atomic';
import modalStatusService from '~/services/modalStatus';
import { useAppDispatch, useAppSelector } from '~/store';
import { selectRecovery } from '~/store/recovery/selectors';
import { confirmPasswordReset } from '~/store/recovery/thunks';

interface FormData {
  password: string;
  confirmPassword: string;
}

export default function ChangePasswordView() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { token, email } = useAppSelector(selectRecovery);
  const [loading, setLoading] = useState(false);

  const { control, handleSubmit, watch } = useForm<FormData>({
    defaultValues: { password: '', confirmPassword: '' },
  });
  const password = watch('password');

  const onSubmit = async ({ password: pwd, confirmPassword }: FormData) => {
    if (!token || !email) {
      navigate('/auth/recovery/email', { replace: true });
      return;
    }
    if (!isPasswordStrong(pwd) || pwd !== confirmPassword) return;
    setLoading(true);
    const logged = await dispatch(
      confirmPasswordReset({ resetToken: token, email, newPassword: pwd }),
    ).unwrap();
    setLoading(false);
    if (logged) {
      modalStatusService.show({
        type: 'success',
        title: 'Senha alterada!',
        description: 'Sua senha foi atualizada e você já está conectado.',
        textFirstButton: 'Continuar',
        showFirstButton: true,
        onClickFirstButton: () => {
          modalStatusService.hide();
          navigate('/app/home', { replace: true });
        },
        handleCloseModal: () => {
          modalStatusService.hide();
          navigate('/app/home', { replace: true });
        },
      });
    }
  };

  return (
    <div className="min-h-screen bg-intense-01 flex flex-col">
      <Header title="Nova senha" />
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex-1 w-full xl:max-w-[440px] mx-auto px-small py-medium flex flex-col gap-medium"
      >
        <Box>
          <Text className="text-headingH1 color-complement-01" as="h1">
            Defina uma nova senha
          </Text>
        </Box>
        <TextInput control={control} name="password" icon="icon-security" placeholder="Nova senha" secureTextEntry />
        <TextInput control={control} name="confirmPassword" icon="icon-security" placeholder="Confirmar senha" secureTextEntry />
        <ValidatePassword value={password} />
        <Button type="submit" fullWidth loading={loading} text="Salvar nova senha" rightIcon="icon-circle-check" />
      </form>
    </div>
  );
}
